var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgArrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7375 0H7.2625C2.7125 0 0 2.7125 0 7.2625V17.725C0 22.2875 2.7125 25 7.2625 25H17.725C22.275 25 24.9875 22.2875 24.9875 17.7375V7.2625C25 2.7125 22.2875 0 17.7375 0ZM20 13.4375H7.2625L11.025 17.2C11.3875 17.5625 11.3875 18.1625 11.025 18.525C10.8375 18.7125 10.6 18.8 10.3625 18.8C10.125 18.8 9.8875 18.7125 9.7 18.525L4.3375 13.1625C4.1625 12.9875 4.0625 12.75 4.0625 12.5C4.0625 12.25 4.1625 12.0125 4.3375 11.8375L9.7 6.475C10.0625 6.1125 10.6625 6.1125 11.025 6.475C11.3875 6.8375 11.3875 7.4375 11.025 7.8L7.2625 11.5625H20C20.5125 11.5625 20.9375 11.9875 20.9375 12.5C20.9375 13.0125 20.5125 13.4375 20 13.4375Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgArrowleft);
export default __webpack_public_path__ + "static/media/img_arrowleft.eb5f234f5df399ec8815dfc553047964.svg";
export { ForwardRef as ReactComponent };